import {
  APP_CONFIG_REQUEST,
  APP_CONFIG_FAILURE,
  APP_CONFIG_SUCCESS,
} from '../constants/actions';
import { fetchM } from './fetchM';
import { handleError } from './error';

function appConfigRequest() {
  return {
    type: APP_CONFIG_REQUEST,
  };
}

function appConfigSuccess(data) {
  return {
    type: APP_CONFIG_SUCCESS,
    payload: {
      data,
    },
  };
}

function appConfigError(message) {
  return {
    type: APP_CONFIG_FAILURE,
    payload: {
      statusText: message,
    },
  };
}

export function fetchAppConfig() {
  return (dispatch) => {
    dispatch(appConfigRequest());
    return dispatch(fetchM('/app/', {
      credentials: 'include',
    }))
      .then(res => res.json())
      .then((data) => {
        dispatch(appConfigSuccess(data));
      })
      .catch(err => dispatch(handleError(err, appConfigError)));
  };
}



// WEBPACK FOOTER //
// ./src/actions/appConfig.js